import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
// tslint:disable-next-line:no-submodule-imports
import { getCountries } from 'react-phone-number-input/input';

// Components
import CountryFlag from './CountryFlag';
import CountryIcon from './CountryIcon';
import CountryOption from './CountryOption';
import ReactSelectPopout from '../../ReactSelectPopout';

type CountrySelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: {}[];
  className?: string;
  countryFlagClassname?: string;
  unicodeFlags?: boolean;
  selectedOption: {};
  iconComponent: React.ComponentType<{}>;
  internationalIcon?: React.ComponentType<{}>;
};

const CountrySelectPopout = (props: CountrySelectProps) => {
  const {
    value: selectValue,
    onChange,
    options,
    className,
    countryFlagClassname,
    unicodeFlags,
    selectedOption,
    iconComponent: Icon,
    ...rest
  } = props;

  return (
    <div className="mr-10">
      <ReactSelectPopout
        {...rest}
        value={selectValue}
        onChange={onChange}
        options={options}
        optionComponent={CountryOption}
      >
        {({
          iconAfter,
          onClick,
          value,
        }: {
          iconAfter?: any;
          onClick: React.MouseEventHandler;
          value?: string;
        }) => (
          <div
            className={clsx('flex items-center', className)}
            onClick={onClick}
          >
            <CountryFlag
              className={countryFlagClassname}
              unicodeFlags={unicodeFlags}
              value={value}
              selectedOption={selectedOption}
              iconComponent={Icon}
              internationalIcon={rest?.internationalIcon}
            />
            {iconAfter}
          </div>
        )}
      </ReactSelectPopout>
    </div>
  );
};

CountrySelectPopout.defaultProps = {
  iconComponent: CountryIcon,
  options: getCountries(),
  unicodeFlags: false,
};

CountrySelectPopout.propTypes = {
  className: PropTypes.string,
  countryFlagClassname: PropTypes.string,
  iconComponent: PropTypes.elementType, // Country flag component.
  locale: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  selectedOption: PropTypes.object,
  unicodeFlags: PropTypes.bool, // Set to `true` to render Unicode flag icons instead of SVG images.
  value: PropTypes.string, // A two-letter country code. Example: "US", "RU". "ZZ" means "International".
};

export default CountrySelectPopout;
